<template>
  <main class="call-center-page" role="main">  
    <div class="row text-center">
      <div class="col align-self-center">
          <h1>Order Complete</h1>
          <h1>Reference Number: {{ reference }}</h1>
          <button class="btn btn-primary btn-lg" @click="restart">Create New Order</button>        
      </div>
    </div>
    
  </main>
</template>

<script>
import EventBus from '@/components/shared/event-bus';
export default {
  name: "call-center-complete",
  components: {
  },
  data() {
    return {
      reference: '',
    };
  },
  computed: {    
  },
  mounted() {  
    EventBus.$emit('hide_menu', true);
    EventBus.$emit('hide_footer', true);
    var refNo = this.$route.query.ref;
    if(refNo) this.reference = refNo;
  },
  methods: {
    restart() {      
      window.location = "/"
    }
  }
};
</script>